import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ACTION, ACTION_SUBJECT, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { logException } from '@atlaskit/editor-common/monitoring';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { disableLoom, enableLoom, insertVideo } from './commands';
export var LoomPluginAction = /*#__PURE__*/function (LoomPluginAction) {
  LoomPluginAction[LoomPluginAction["ENABLE"] = 0] = "ENABLE";
  LoomPluginAction[LoomPluginAction["DISABLE"] = 1] = "DISABLE";
  LoomPluginAction[LoomPluginAction["RECORD_VIDEO"] = 2] = "RECORD_VIDEO";
  LoomPluginAction[LoomPluginAction["INSERT_VIDEO"] = 3] = "INSERT_VIDEO";
  return LoomPluginAction;
}({});
export var loomPluginKey = new PluginKey('loom');
var LOOM_SDK_PUBLIC_APP_ID = 'e1cff63a-8ca2-4c2c-ad41-d61c54beb16a';
export var createPlugin = function createPlugin(api) {
  var _api$analytics;
  var editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
  return new SafePlugin({
    key: loomPluginKey,
    state: {
      init: function init() {
        return {
          isEnabled: false,
          loomButton: null,
          isRecordingVideo: false,
          error: undefined
        };
      },
      apply: function apply(tr, pluginState) {
        var _tr$getMeta, _pluginState$loomButt;
        var action = (_tr$getMeta = tr.getMeta(loomPluginKey)) === null || _tr$getMeta === void 0 ? void 0 : _tr$getMeta.type;
        switch (action) {
          case LoomPluginAction.ENABLE:
            var _tr$getMeta2 = tr.getMeta(loomPluginKey),
              loomButton = _tr$getMeta2.loomButton;
            return _objectSpread(_objectSpread({}, pluginState), {}, {
              isEnabled: true,
              loomButton: loomButton
            });
          case LoomPluginAction.DISABLE:
            var _tr$getMeta3 = tr.getMeta(loomPluginKey),
              error = _tr$getMeta3.error;
            return _objectSpread(_objectSpread({}, pluginState), {}, {
              isEnabled: false,
              loomButton: null,
              error: error
            });
          case LoomPluginAction.RECORD_VIDEO:
            // Click the unmounted button in state that has the Loom SDK attached
            pluginState === null || pluginState === void 0 || (_pluginState$loomButt = pluginState.loomButton) === null || _pluginState$loomButt === void 0 || _pluginState$loomButt.click();
            return _objectSpread(_objectSpread({}, pluginState), {}, {
              isRecordingVideo: true
            });
          case LoomPluginAction.INSERT_VIDEO:
            return _objectSpread(_objectSpread({}, pluginState), {}, {
              isRecordingVideo: false
            });
          default:
            return pluginState;
        }
      }
    },
    view: function view(editorView) {
      var setupLoom = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _api$core3, _api$analytics3;
          var _yield$import, isSupported, setup, _yield$isSupported, supported, error, _api$core, _api$analytics2, _yield$setup, configureButton, loomButton, sdkButton;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return import( /* webpackChunkName: "@atlaskit-internal_editor-loom-sdk" */'@loomhq/record-sdk');
              case 2:
                _yield$import = _context2.sent;
                isSupported = _yield$import.isSupported;
                setup = _yield$import.setup;
                _context2.next = 7;
                return isSupported();
              case 7:
                _yield$isSupported = _context2.sent;
                supported = _yield$isSupported.supported;
                error = _yield$isSupported.error;
                if (supported) {
                  _context2.next = 15;
                  break;
                }
                // Keep plugin state update and analytics separate to avoid accidentally not updating
                // plugin state due to collab-edit filtering out transactions with steps
                api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(disableLoom({
                  error: error
                }));
                logException(new Error(error), {
                  location: 'editor-plugin-loom/sdk-initialisation'
                });
                // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
                // filters out any transactions with steps (even analytics) when it's initialising
                api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.fireAnalyticsEvent({
                  action: ACTION.ERRORED,
                  actionSubject: ACTION_SUBJECT.LOOM,
                  eventType: EVENT_TYPE.OPERATIONAL,
                  attributes: {
                    error: error
                  }
                });
                return _context2.abrupt("return");
              case 15:
                _context2.next = 17;
                return setup({
                  publicAppId: LOOM_SDK_PUBLIC_APP_ID
                });
              case 17:
                _yield$setup = _context2.sent;
                configureButton = _yield$setup.configureButton;
                // Hidden element to work around the SDK API
                loomButton = document.createElement('button');
                sdkButton = configureButton({
                  element: loomButton
                }); // Attach insertion logic to the event handlers on the SDK
                sdkButton.on('insert-click', /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(video) {
                    var _api$hyperlink, _api$core2;
                    var state, dispatch, pos;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          state = editorView.state, dispatch = editorView.dispatch;
                          pos = editorView.state.selection.from;
                          api === null || api === void 0 || (_api$hyperlink = api.hyperlink) === null || _api$hyperlink === void 0 || _api$hyperlink.actions.insertLink(INPUT_METHOD.TYPEAHEAD, pos,
                          // from === to, don't replace text to avoid accidental content loss
                          pos, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed' // Convert to embed card instead of inline
                          )(state, dispatch);
                          api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(insertVideo({
                            editorAnalyticsAPI: editorAnalyticsAPI,
                            video: video
                          }));
                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(enableLoom({
                  loomButton: loomButton
                }));
                // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
                // filters out any transactions with steps (even analytics) when it's initialising
                api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || _api$analytics3.actions.fireAnalyticsEvent({
                  action: ACTION.INITIALISED,
                  actionSubject: ACTION_SUBJECT.LOOM,
                  eventType: EVENT_TYPE.OPERATIONAL
                });
              case 24:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function setupLoom() {
          return _ref.apply(this, arguments);
        };
      }();
      setupLoom();
      return {};
    }
  });
};